import { render, staticRenderFns } from "./product-entity-relations-list.vue?vue&type=template&id=d8d51660&scoped=true&"
import script from "./product-entity-relations-list.vue?vue&type=script&lang=js&"
export * from "./product-entity-relations-list.vue?vue&type=script&lang=js&"
import style0 from "./product-entity-relations-list.vue?vue&type=style&index=0&id=d8d51660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d51660",
  null
  
)

export default component.exports